import {useCurrentFlowId, useParsedBookingQuery} from "@page-containers/booking/utils/bookingQuery";
import {BookingStep} from "@page-containers/booking/utils/bookingStep";
import {getMilesAway} from "@page-containers/booking/utils/webBookingAnalytics";
import {MonolithLocationFields} from "@services/graphql/queries/location";
import {useEffect, useState} from "react";
import {v4} from "uuid";

import {CustomCategory, EventCategory, EventType} from "../../../../../utils/analytics/constants";
import {queueEvent} from "../../../../../utils/analytics/eventQueue";
import {useGeolocation} from "../../../../../utils/browser-storage/location";

export const useSlotReselectionStepViewedEvent = (
  location: MonolithLocationFields,
  specialtyId: string,
  apptReasonId?: string,
) => {
  const [viewId] = useState(v4());

  const {rescheduling} = useParsedBookingQuery();
  const userPosition = useGeolocation();
  const flowId = useCurrentFlowId();

  useEffect(() => {
    if (userPosition) {
      queueEvent({
        category: EventCategory.Custom,
        typeId: EventType.TimeReselectionStepViewed,
        extraData: {
          category: CustomCategory.AppointmentScheduling,
          bookingStep: BookingStep.TIME_RESELECTION,
          apptDetails: {
            apptReasonId,
            specialtyId,
            locationId: location?.id,
            milesAway: location ? getMilesAway(userPosition, location) : undefined,
          },
          viewId,
          flowId,
        },
      });
    }
  }, [viewId, apptReasonId, flowId, location, specialtyId, userPosition, rescheduling]);

  return viewId;
};
